import type { CoverLetterDocumentType } from '@xing-com/crate-lebenslauf-shared-client-document-variable';

import type { AddSkill } from '../types/SharedActions';
import { updateLocalStorage } from './updateLocalStorage';

export const addSkill = (
  doc: CoverLetterDocumentType,
  value: AddSkill['value']
): void => {
  const skillNames = doc.skills?.map((item) => item?.skill);
  const skillNamesSet = new Set(skillNames);

  skillNamesSet.add(value);

  const skillsUpdated = [...skillNamesSet].map((skill) => ({ skill }));

  updateLocalStorage(`skills`, skillsUpdated);
};
